import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import * as ratingsActions from '../../../ratings/actions';

export class RatingsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt, value) {
        this.setState({
            value
        });
    }

    handleRatingChange(evt) {
        const params = {
            type: 'oi',
            projectState: 'Nebraska',
            anticipatedProjectLength: 12,
            totalCost: 5000000
        };
        this.props.fetchRatings(params);
    }

    render() {
        return (
            <div>
                <h4>Ratings Container</h4>
                <p>
                    {Object.keys(this.props.ratings).map(
                        ratingKey =>
                            `${ratingKey}: ${JSON.stringify(this.props.ratings[ratingKey])}, `
                    )}
                </p>

                <Button className="btn" onClick={evt => this.handleRatingChange(evt)}>
                    Fetch Ratings
                </Button>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        app: store.app,
        user: store.user,
        ratings: store.ratings
    };
};

export default connect(mapStateToProps, { fetchRatings: ratingsActions.fetch })(RatingsContainer);
